module.exports = __webpack_public_path__ + "static/media/icon-tel.7a41e4a3.svg";